import EyeIcon from '@/assets/icons/eye-ace.svg?react';
import RepeatButtonIcon from '@/assets/icons/repeat-button-ace.svg?react';
import SpadeIcon from '@/assets/icons/spade-suit.svg?react';
import SparklingHeartIcon from '@/assets/icons/sparkling-heart-ace.svg?react';
import HighVoltageIcon from '@/assets/icons/voltage-ace.svg?react';
import { AceCardImage } from '@/features/subscription/components/aceCardImage';
import {
  SubscriptionDialogBody,
  SubscriptionDialogContent,
  SubscriptionDialogDescription,
  SubscriptionDialogFooter,
  SubscriptionDialogHeader,
  SubscriptionDialogHeading,
  SubscriptionDialogNotice,
  SubscriptionDialogSection,
  SubscriptionDialogTitle,
} from '@/features/subscription/components/subscriptionDialog';
import { Button } from '@/shared/components/ui/button';

export interface BenefitsPageProps {
  onContinue: () => void;
}

const features = [
  {
    key: 'likes',
    Icon: SparklingHeartIcon,
    text: 'See who liked you and who revealed you',
  },
  {
    key: 'swipes',
    Icon: RepeatButtonIcon,
    text: 'Unlimited swipes - no limits, no cooldown',
  },
  {
    key: 'reveals',
    Icon: EyeIcon,
    text: 'Unlimited card reveals to discover potential duos',
  },
  {
    key: 'visibility',
    Icon: HighVoltageIcon,
    text: 'Show up first in swipe discovery',
  },
];

export function BenefitsPage({ onContinue }: BenefitsPageProps) {
  return (
    <SubscriptionDialogContent>
      <SubscriptionDialogBody>
        <SubscriptionDialogHeader>
          <AceCardImage className="h-37.5" />
          <SubscriptionDialogHeading>
            <SubscriptionDialogTitle>
              Find more quality duos faster with{' '}
              <span className="text-cardpink-400">Ace</span>
            </SubscriptionDialogTitle>
            <SubscriptionDialogDescription>
              Your card levels up to our Ace tier - more visibility, more duos.
            </SubscriptionDialogDescription>
          </SubscriptionDialogHeading>
        </SubscriptionDialogHeader>

        <SubscriptionDialogSection>
          {features.map(({ Icon, key, text }) => (
            <div key={key} className="flex items-center gap-4">
              <Icon className="size-11" />
              <p className="font-nunito flex-1 text-base leading-relaxed font-semibold text-white">
                {text}
              </p>
            </div>
          ))}
        </SubscriptionDialogSection>

        <SubscriptionDialogNotice>
          Cancel anytime, no penalties or fees
        </SubscriptionDialogNotice>
      </SubscriptionDialogBody>

      <SubscriptionDialogFooter>
        <Button
          variant="destructive"
          size="lg"
          className="w-full"
          onClick={onContinue}
        >
          <SpadeIcon className="size-5 text-black" />
          Become an Ace
        </Button>
      </SubscriptionDialogFooter>
    </SubscriptionDialogContent>
  );
}
